<div [formGroup]="formGroup">
  <div
    class="grid grid-cols-12 gap-4 rounded-lg w-full max-w-md items-center mb-1"
  >
    <div class="col-span-3 md:col-span-6">
      <label for="text" class="block text-2sm font-medium text-dark">{{
        fields.displayName
      }}</label>
    </div>

    <div class="col-span-9 md:col-span-6">
      <div
        *ngIf="selectedFileName.length == 0"
        class="upload-box"
        [class.dragover]="isDragOver"
        (click)="openFilePicker()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onFileDrop($event)"
      >
        <div class="upload-row">
          <img
            src="./assets/media/icons/file-download.png"
            class="upload-icon"
            alt="Upload"
          />
          <span class="upload-text text-center">
            <span
              (click)="openFilePicker($event)"
              class="text-sm font-medium text-underline"
              >Click To upload</span
            >

            <span class="text-sm text-gray-500 ms-1">or drag on drop</span>
          </span>

          <input
            type="file"
            #fileInput
            hidden
            (change)="onFileSelected($event)"
          />
        </div>
      </div>
      <ng-container *ngIf="selectedFileName">
        <div
          *ngFor="let file of selectedFileName; let i = index"
          class="flex items-center justify-between border rounded-lg p-2 border-gray-500"
        >
          <div class="flex items-center gap-2 w-[75%] truncate">
            <img class="h-30px w-30px" [src]="getFileIcon(file.name)" />
            <span class="text-sm font-medium text-gray-700 truncate">
              {{
                file.name.length > 40
                  ? (file.name | slice : 0 : 40) + "…"
                  : file.name
              }}
            </span>
          </div>
          <button
            class="btn btn-icon btn-sm btn-light text-red-500"
            (click)="removeFile(i)"
          >
            <i class="ki-filled ki-trash"></i>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
